module.exports = __webpack_public_path__ + "static/media/auction-status.ab33aa02.svg";